//imports
import {
    TRANSACTIONS_DETAILS_OPEN_MODAL,
    TRANSACTIONS_DETAILS_CLOSE_MODAL,
    TRANSACTIONS_DETAILS_RESULT_REQUEST,
    TRANSACTIONS_DETAILS_RESULT_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    transactionId: null,
    type: null,
    data: null,
    openModal: false,
}

//transactions redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case TRANSACTIONS_DETAILS_OPEN_MODAL:
            return { ...state, openModal: true, transactionId: action.payload.transactionId, type: action.payload.type }

        case TRANSACTIONS_DETAILS_CLOSE_MODAL:
            return { ...state, openModal: false, transactionId: null }

        case TRANSACTIONS_DETAILS_RESULT_REQUEST:
            return { ...state, loading: true }
        case TRANSACTIONS_DETAILS_RESULT_RESULT:
            return {
                ...state,
                loading: false,
                transactions: action.payload.oldNextToken
                    ? [...state.transactions, ...action.payload.transactions]
                    : action.payload.transactions,
                nextToken: action.payload?.nextToken
            }

        case CLEAR_REDUX:
            return ["", "TRANSACTIONS_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};